import iconList from '@/components/iconList.vue';
export default {
  components: {
    iconList
  },
  data() {
    return {
      dialogVisible: false,
      iconName: ''
    };
  },
  methods: {
    init() {
      this.iconName = '';
      this.dialogVisible = true;
    },
    iocnOk(name) {
      this.iconName = name;
      console.log(name);
    },
    handleSure() {
      this.$emit('iconOk', this.iconName);
      this.$emit('cancel');
    }
  }
};